import React, {Component} from "react";
import PrettyCheckbox from "../../../pretty_checkbox/PrettyCheckbox";

class Checkbox extends Component {

    state = {
        checked: false,
        disabled: false
    }

    onCheckChange = () => {
        const newState = {checked: !this.state.checked};
        this.setState({...this.state, ...newState});
        if (this.props.onCheckChange)
            this.props.onCheckChange(newState);
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        let checked = this.state.checked;
        let disabled = this.state.disabled;

        if (nextProps.checked !== checked) {
            checked = nextProps.checked;
        }
        if (nextProps.disabled !== disabled) {
            disabled = nextProps.disabled;
        }

        this.setState({
            checked,
            disabled
        });
    }

    render() {
        // Replaced from state to props.
        const { accessKey, checked, disabled } = this.props;

        return (
            <PrettyCheckbox onCheckChange={this.onCheckChange} accessKey={accessKey} checked={checked} disabled={disabled}></PrettyCheckbox>
        );
    }
}

export default Checkbox;